

export default {

    name: 'signup_employee',

    props: {
        afterSignUp: {
            type: Function,
            required: false,
            default: null
        },
        preset: {
            type: Object,
            required: false,
            default: null
        },
        managerMode: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    created() {

        let t = this;

        t.list.country = window['COUNTRY_LIST'];

        t.list.country.forEach(item => {
            item.icon = 'assets/img/flag/' + item.code + '.svg';
        });

        t.dict.country = listToDict(t.list.country, 'code');

        t.termIsChecked = true;
    },
    activated() {
        let t = this;
    },
    methods: {

        onSelectCountry(item) {
            this.f.country = item.code;
        },

        async signUp() {
            let t = this;
            let f = t.f;

            if (t.busying)
                return;

            mirror(t.msg_o, t.msg);

            let go = true;

            if (!f.firstname) {
                t.msg.firstname = 'Required';
                go = false;
            }

            if (!f.lastname) {
                t.msg.lastname = 'Required';
                go = false;
            }

            if (!f.username) {
                t.msg.username = 'Required';
                go = false;
            }

            if (!/^[a-zA-Z0-9]{8,}$/.test(f.username)) {
                t.msg.username = '半角英数字を8文字以上入力してください。';
                go = false;
            }

            if (f.password.length < 6) {
                t.msg.password = 'Password length must be at least 6 digits';
                go = false;
            }

            if (!f.tel) {
                t.msg.tel = 'Required';
                go = false;
            }


            if (!t.managerMode) {

                if (!f.address) {
                    t.msg.address = 'Required';
                    go = false;
                }


                if (!f.email) {
                    t.msg.email = 'Required';
                    go = false;
                }

                if (!/^[a-zA-Z0-9\.]{1,}@[a-zA-Z0-9\.]{1,}[a-zA-Z0-9]$/.test(f.email)) {
                    t.msg.email = 'Please enter a valid email address';
                    go = false;
                }

                if (f.country != 'jp' && !t.residenceCardIsUploaded) {
                    A.err('Please upload your residence card.');
                    go = false;
                }

                if (!t.termIsChecked) {
                    t.msg.terms = 'Please accept the T&C';
                    go = false;
                }
            }


            if (!go)
                return;

            function _post() {

                t.busying = true;

                let data = getFields(f, ['firstname', 'lastname', 'address', 'email', 'password', 'tel', 'country', 'rc_img_url', 'username', 'unit_id', 'avatar_url']);

                if (t.preset) {
                    mirror(t.preset, data);
                }
                axios.post('employee/signUp2', data).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {

                        if (t.managerMode) {
                            t.afterSignUp();
                        }
                        else {
                            A.show('Please remember your username and password, it will use to sign in.', 'You finished signup.', 'success').then(res => {
                                t.$router.replace('/signin');
                            });
                        }
                    }
                    else if (res.data.status == 2) {
                        A.err('Email or ID already exists');
                    }
                });

            }

            if (f.country != 'jp' && t.residenceCardIsUploaded) {
                let fd = new FormData();

                fd.append('image', t.rcImageBlob);

                t.busying = true;

                await axios.post('employee/uploadRC', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        f.rc_img_url = res.data.options.img_url;
                    }

                });

            }


            if (t.avatarImageBlob) {

                let fd = new FormData();

                fd.append('image', t.avatarImageBlob);

                t.busying = true;

                await axios.post('employee/uploadAvatar', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        f.avatar_url = res.data.options.img_url;
                    }

                });
            }

            _post();


        },

        closeCropper() {
            $('.cropper-item-signup').hide();
        },

        confirmCropper() {

            let t = this;

            t.cropper.getCroppedCanvas({
                minHeight: 600,
                minWdith: 600,
                maxHeight: 1000,
                maxWdith: 1000,
                fillColor: '#fff',
            }).toBlob((blob) => {

                if (t.uploadImgType == "rc") {
                    t.rcImageBlob = blob;

                    t.residenceCardIsUploaded = true;
                }
                else if (t.uploadImgType == "avatar") {
                    t.avatarImageBlob = blob;
                    t.avatarImageBlobUrl = getObjectURL(t.avatarImageBlob);
                }

                t.closeCropper();
            });
        },

        uploadPicture() {

            let t = this;

            t.uploadImgType = "rc";

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById('cropperImgSignUp');

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 4 / 3,
                        autoCropArea: 1,
                        crop(event) {
                        },
                    });
                    $('.cropper-item-signup').show();
                }

                event.target['value'] = '';


            };

            ImageUploader.openSelector();
        },

        uploadAvatar() {
            let t = this;

            t.uploadImgType = "avatar";

            ImageUploader.onSelectImage = (file) => {
                file = event.target["files"][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById("cropperImgSignUp");

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 1 / 1,
                        autoCropArea: 1,
                        crop(event) { },
                    });
                    $('.cropper-item-signup').show();
                };

                event.target["value"] = "";
            };

            ImageUploader.openSelector();
        },
    },
    data() {
        return {
            residenceCardIsUploaded: false,
            termIsChecked: false,
            showCountryPopover: false,
            showBusinessPopover: false,
            msg: {
                firstname: '',
                lastname: '',
                address: '',
                email: '',
                username: '',
                tel: '',
                password: '',
                terms: '',
            },
            msg_o: {
                firstname: '',
                lastname: '',
                address: '',
                email: '',
                username: '',
                tel: '',
                password: '',
                terms: '',
            },
            f: {
                firstname: '',
                lastname: '',
                address: '',
                email: '',
                username: '',
                country: 'jp',
                tel: '',
                password: '',
                business_str: ''
            },

            list: {
                business: [],
                country: []
            },
            dict: {
                country: {}
            },

            rcImageBlob: null,
            avatarImageBlob: null,
            avatarImageBlobUrl: '',
            uploadImgType: '',
            cropper: null,
        };
    },
};
